export function initNotifications() {
  const container = document.querySelector('[data-notifications]');
  if (!container) return;

  const btn = container.querySelector('[data-notifications-trigger]');
  const menu = container.querySelector('[data-notifications-menu]');
  if (!btn || !menu) return;

  btn.addEventListener('click', e => {
    e.stopPropagation();
    menu.classList.toggle('hidden');
  });

  document.addEventListener('click', e => {
    if (!container.contains(e.target)) {
      menu.classList.add('hidden');
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') menu.classList.add('hidden');
  });
}
